import styled from 'styled-components';

import { Button } from '../Shared/FormStyles';
import { PageTitle } from '../Shared/CommonStyles';

export const PageTitleContainer = styled.div`
	display: flex;
	align-items: baseline;
	flex-wrap: wrap; 
	gap: 1.5rem; 

	& > ${PageTitle} {
		width: auto;
	}
`;

export const AlbumTitle = styled.h2`
	margin: 0;
	padding: 0;
	color: var(--color-secondary, #34495e);
	line-height: 1.3;
	font-size: 1.75rem;
	font-weight: 600;

	@media (max-width: 768px) {
		font-size: 1.5rem; 
	}
`;

// Row container for the Page Title and Pagination controls
export const TitleRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center; 
	flex-wrap: wrap; 
	gap: 16px; 
	width: 100%;
	margin-bottom: 32px;

	@media (max-width: 768px) {
		margin-bottom: 24px;
	}
`;

export const AlbumViewControls = styled.div`
	display: flex;
	flex-direction: column; 
	width: 100%;
	margin-bottom: 32px;
	gap: 16px;

	@media (max-width: 768px) {
		gap: 16px;
		margin-bottom: 24px;
	}
`;

export const AlbumTitleRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	gap: 16px;
	flex-wrap: wrap; 
`;

export const AlbumTitleSection = styled.div`
	display: flex;
	align-items: center;
	gap: 16px; 
	min-width: 0; 

	h2 {
		margin: 0;
		padding: 0;
		font-size: 1.75rem;
		color: var(--color-secondary, #34495e);
		line-height: 1.3;

		@media (max-width: 768px) {
			display: none;
		}
	}
`;

// Container for Edit Buttons
export const EditButtonsContainer = styled.div`
	display: flex;
	gap: 8px;
	flex-shrink: 0; 
	margin-left: auto; 

	& > ${Button}, & > a {
		padding: 6px 12px;
		font-size: 0.85rem;
		margin-top: 0; 
		align-self: center; 
	}

	@media (max-width: 500px) {

	}
`;
export const PaginationContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%; 
	overflow: visible; 
`;

// Integrated container that looks like a single unit with pagination
export const IntegratedControlsContainer = styled.div`
	display: flex;
	align-items: stretch; 
	background: white;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

	width: 100%; 

	@media (max-width: 768px) {
		flex-wrap: wrap;
	}

	& > div:first-child {
		margin: 0;
		box-shadow: none;

		flex-grow: 1;
	}
`;

// New wrapper for tabs + inline slider
export const TabsAndFilterRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: stretch;
	width: 100%;
	margin-bottom: 32px;
	border-bottom: 1px solid #ddd;

	@media (max-width: 900px) {
		flex-direction: column;
		border-bottom: none;
		gap: 16px;
	}

	@media (max-width: 768px) {
		margin-bottom: 24px;
	}
`;

// Wrapper for tabs
export const TabsWrapper = styled.div`
	display: flex;
	flex: 1;
	min-width: 0;
	overflow: hidden;

	@media (max-width: 900px) {
		width: 100%;
		border-bottom: 1px solid #ddd;
	}
`;

// Compact inline slider container (replaces YearFilterContainer for inline use)
export const YearFilterInline = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 16px;
	flex-shrink: 0;
	background-color: transparent;
	border-left: 1px solid #eee;

	@media (max-width: 900px) {
		width: 100%;
		justify-content: center;
		padding: 12px 16px;
		background-color: #f8f9fa;
		border-radius: 8px;
		border-left: none;
		flex-wrap: wrap;
	}
`;

// Compact slider container
export const SliderContainerInline = styled.div`
	width: 150px;
	padding: 0;
	display: flex;
	align-items: center;

	.rc-slider {
		width: 100%;
	}

	.rc-slider-handle {
		width: 14px !important;
		height: 14px !important;
		margin-top: -5px !important;
	}

	.rc-slider-handle:hover,
	.rc-slider-handle:focus,
	.rc-slider-handle-dragging {
		border-color: var(--color-accent-dark, #0056b3) !important;
		box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25) !important;
	}

	@media (max-width: 900px) {
		width: 100%;
		max-width: 300px;
		padding: 8px 0;
	}
`;

export const TabsContainer = styled.div`
	display: flex;
	overflow-x: auto;
	scrollbar-width: thin;
	scrollbar-color: #ccc #f0f0f0;
	width: 100%;

	&::-webkit-scrollbar {
		height: 6px;
	}
	&::-webkit-scrollbar-track {
		background: #f0f0f0;
	}
	&::-webkit-scrollbar-thumb {
		background-color: #ccc;
		border-radius: 3px;
	}
`;

export const Tab = styled.button<{ $active: boolean }>`
	padding: 12px 24px; 
	background: transparent;
	border: none;
	border-bottom: 3px solid transparent; 
	border-bottom-color: ${(props) =>
		props.$active ? 'var(--color-accent, #007bff)' : 'transparent'};
	cursor: pointer;
	font-size: 1rem;
	font-weight: ${(props) => (props.$active ? '600' : '400')};
	color: ${(props) =>
		props.$active ? 'var(--color-accent, #007bff)' : '#333'};
	transition: all 0.2s ease;
	white-space: nowrap; 
	flex-shrink: 0; 

	&:hover {
		background: #f5f5f5;
		color: var(--color-accent-dark, #0056b3);
	}

	@media (max-width: 768px) {
		padding: 10px 16px; 
		font-size: 0.95rem;
	}
`;

export const BackButton = styled.button`
	padding: 10px 16px; 
	background-color: var(--color-secondary-light, #ecf0f1);
	color: var(--color-secondary-dark, #2c3e50);
	border: none;
	border-radius: 5px;
	cursor: pointer;
	display: inline-flex; 
	align-items: center;
	gap: 8px;
	font-size: 0.95rem;
	transition: background-color 0.2s ease, transform 0.1s ease;
	white-space: nowrap; 

	&:hover {
		background-color: var(--color-secondary-lighter, #dde4e6);
		transform: translateY(-1px);
	}
	&:active {
		transform: translateY(0);
	}

	@media (max-width: 768px) {
		margin-left: 0;
		margin-top: 8px;
		padding: 8px 16px;
	}
`;

// Styled version of the back button that matches pagination styling
export const IntegratedBackButton = styled(BackButton)`
	background-color: white;
	margin: 0;
	height: auto; 
	border-radius: 0 8px 8px 0;
	border-left: 1px solid #eee;
	padding: 8px 16px;
	align-self: stretch; 
	display: flex;
	align-items: center;

	&:hover {
		background-color: #f5f5f5;
		transform: none;
	}

	@media (max-width: 768px) {
		width: 100%;
		justify-content: center;
		border-left: none;
		border-top: 1px solid #eee;
		padding: 12px 16px; 
	}
`;

// Mobile-only button (visible only on mobile)
export const MobileBackButton = styled(BackButton)`

	@media (min-width: 769px) {
		display: none;
	}
`;

// Desktop-only button (hidden on mobile)
export const DesktopBackButton = styled(IntegratedBackButton)`
	@media (max-width: 768px) {
		display: none;
	}
`;

// Simple horizontal separator line
export const Separator = styled.div`
	width: 100%;
	height: 1px;
	background-color: #e0e0e0; 
	margin-bottom: 32px; 

	@media (max-width: 768px) {
		margin-bottom: 24px; 
	}
`;

// Year Filter Container - wraps the entire filter section
export const YearFilterContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 16px 20px;
	background-color: #f8f9fa;
	border-radius: 8px;
	margin-bottom: 24px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

	@media (max-width: 768px) {
		padding: 12px 16px;
		margin-bottom: 20px;
	}
`;

// Label for the year filter
export const YearFilterLabel = styled.label`
	font-size: 0.85rem;
	font-weight: 500;
	color: var(--color-secondary, #34495e);
	white-space: nowrap;

	@media (max-width: 900px) {
		font-size: 0.95rem;
	}
`;

// Wrapper for the slider and display
export const YearSliderWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

// Display showing the currently selected range
export const YearRangeDisplay = styled.div`
	font-size: 0.9rem;
	font-weight: 600;
	color: var(--color-accent, #007bff);
	white-space: nowrap;
	min-width: 110px;
	text-align: center;

	@media (max-width: 900px) {
		font-size: 1rem;
		min-width: auto;
	}
`;

// Container for the slider itself
export const SliderContainer = styled.div`
	padding: 8px 10px 24px 10px;

	.rc-slider {
		width: 100%;
	}

	.rc-slider-handle:hover,
	.rc-slider-handle:focus,
	.rc-slider-handle-dragging {
		border-color: var(--color-accent-dark, #0056b3) !important;
		box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25) !important;
	}

	.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
		border-color: var(--color-accent-dark, #0056b3) !important;
		box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.3) !important;
	}
`;

// Labels showing the min and max years below the slider
export const SliderLabels = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 8px;
	font-size: 0.8rem;
	color: #666;

	span {
		white-space: nowrap;
	}
`;

export const PseudoAlbumCard = styled.div`
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
	padding: 20px;
	gap: 12px;
	min-height: 200px;
	justify-content: flex-end;

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
	}

	span {
		font-size: 1.1rem;
		font-weight: 600;
	}
`;

export const ShowAllPhotosButton = styled.button`
	background-color: #17a2b8;
	color: white;
	border: none;
	padding: 8px 16px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 0.9rem;
	margin-left: auto;
	margin-right: auto;
	display: block;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #138496;
	}
`;

// Big prominent button for classification of provisional albums
export const ClassifyButton = styled.button`
	display: inline-block;
	padding: 14px 36px;
	font-size: 1.15rem;
	font-weight: 700;
	color: white;
	background: #e67e22;
	border: none;
	border-radius: 8px;
	cursor: pointer;
	text-transform: uppercase;
	letter-spacing: 1px;

	&:hover {
		background: #d35400;
	}
`;